<div class="registration-payment">
  <div class="registration-payment-container" [class.edit]="editingBillingAddress || editingShippingAddress">
    <!-- PAYMENT SUMMARY -->
    <ng-container *ngIf="basket$ | async as basket; else loading">
      <div class="registration-payment-content" *ngIf="basket">
        <!-- Left Side -->
        <div class="registration-payment-basket">
          <div class="registration-payment-header">
            <h5 class="registration-payment-title">{{ 'fgbcl.registration.payment.header.title' | translate }}</h5>
          </div>
          <h5 class="summary-title">{{ 'fgbcl.registration.payment.item.summary.title' | translate }}</h5>

          <div class="registration-basket-item" *ngFor="let basketItem of basket.BasketItems">
            <img alt="" class="membership-image" [src]="basketItem.DisplayImage | contentImage : '4'" />
            <div class="basket-item">
              <span class="registration-basket-item-desc"
                ><span class="basket-label">{{ basketItem.DisplayText }}</span>
                <span class="basket-item">&nbsp;- {{ basketItem.MembershipOption.DisplayName }}</span></span
              >
              <span class="registration-basket-item-cost"
                ><span class="basket-label">{{
                  'fgbcl.registration.payment.cost.label' | translate : { fgbdefault: 'Cost' }
                }}</span>
                <span class="price ms-2">{{ basketItem.Price / 100 | FortressCurrencyPipe }}</span></span
              >
            </div>
          </div>
          <button class="back-btn d-lg-flex d-none" (click)="back()">
            {{ 'fgbcl.registration.payment.back.button' | translate }}
          </button>
        </div>

        <!-- Right Side -->
        <div [ngClass]="{ 'd-none': editingBillingAddress || editingShippingAddress }" class="registration-payment-summary">
          <!-- Billing Address Card -->
          <ng-container
            *ngTemplateOutlet="
              addressTemplate;
              context: {
                $implicit: billingAddressForm?.value,
                title: 'fgbcl.registration.payment.billing.address.title' | translate : { fgbdefault: 'Billing Address' },
                type: 'billing'
              }
            "
          >
          </ng-container>

          <!-- Summary -->
          <div class="card summary-card">
            <h5 class="summary-card-title">
              {{ 'fgbcl.registration.payment.summary.title' | translate : { fgbdefault: 'Summary' } }}
            </h5>
            <div class="summary-item">
              <span class="summary-label">{{ 'fgbcl.registration.payment.summary.items.total.label' | translate }}</span>
              <span class="summary-value">{{ basket.TotalPrice / 100 | FortressCurrencyPipe }}</span>
            </div>
            <div class="summary-item" *ngIf="basket?.TotalTax > 0">
              <span class="summary-label">{{
                'fgbcl.registration.payment.summary.tax.label' | translate : { fgbdefault: 'Tax:' }
              }}</span>
              <span class="summary-value">{{ basket.TotalTax / 100 | FortressCurrencyPipe }}</span>
            </div>
            <div class="summary-item" *ngIf="basket?.TotalShipping > 0">
              <span class="summary-label">{{
                'fgbcl.registration.payment.summary.shipping.label' | translate : { fgbdefault: 'Shipping:' }
              }}</span>
              <span class="summary-value">{{ basket.TotalShipping / 100 | FortressCurrencyPipe }}</span>
            </div>
            <!-- TODO: No XD for gift codes -->
            <div class="summary-total" *ngIf="appliedGiftCodes && appliedGiftCodes.length > 0">
              <span class="summary-label">{{
                'fgbcl.registration.payment.summary.discount.label' | translate : { fgbdefault: 'Discount Code(s):' }
              }}</span>
              <span class="summary-value" *ngFor="let giftCode of appliedGiftCodes">
                <div class="heading-text">
                  <button (click)="removeGiftCode(giftCode.Code)">
                    <label class="accessibility-only">{{ 'registration.remove.giftcode.screenreader' | translate }}</label>
                    <span aria-hidden="true">X</span>
                  </button>
                  {{ giftCode.Code }}
                </div>
                <div class="col-3 text-end">
                  <span *ngIf="giftCode.EntitlementValueType == 0"
                    >- {{ giftCode.EntitlementValue / 100 | FortressCurrencyPipe }}</span
                  >
                  <span *ngIf="giftCode.EntitlementValueType == 1">- {{ giftCode.EntitlementValue }}%</span>
                  <span *ngIf="giftCode.EntitlementValueType == 2">FREE</span>
                </div>
              </span>
            </div>
            <hr />
            <div class="summary-total">
              <span class="summary-label">{{
                'fgbcl.registration.payment.summary.total.label' | translate : { fgbdefault: 'Total:' }
              }}</span>
              <span class="summary-value">{{ totalBasketPrice / 100 | FortressCurrencyPipe }}</span>
            </div>
          </div>
          <!-- Server Side Errors -->
          <fgbcl-errors></fgbcl-errors>

          <div class="action-wrapper">
            <button class="btn btn-success payment-btn" (click)="submitStep()">
              <span class="d-flex">
                {{ 'fgbcl.registration.payment.button' | translate : { fgbdefault: 'Proceed to Payment' } }}
              </span>
            </button>
            <button class="btn text-danger fw-bold d-flex d-lg-none" (click)="back()">
              {{ 'fgbcl.registration.payment.back.button' | translate : { fgbdefault: 'Cancel' } }}
            </button>
          </div>
        </div>

        <!-- EDIT BILLING ADDRESS FORM -->
        <ng-container *ngIf="editingBillingAddress">
          <div class="billing-address-form">
            <div class="position-relative rounded registration-payment-billing-form">
              <div class="form-header">
                <h5 class="form-header-title">
                  {{ 'fgbcl.registration.payment.billing.form.title' | translate : { fgbdefault: 'Billing Address' } }}
                </h5>
                <a class="clear-btn" (click)="clearAddressForm(billingAddressForm)">{{
                  'fgbcl.registration.payment.form.clear.button' | translate : { fgbdefault: 'Clear Form' }
                }}</a>
              </div>
              <form [formGroup]="billingAddressForm">
                <div class="form-floating">
                  <input
                    id="Street"
                    class="form-control"
                    name="Street"
                    type="text"
                    formControlName="Street"
                    [ngClass]="{
                      'is-invalid': haSubmittedBillingAddress && !!billingAddressForm.controls.Street.errors
                    }"
                  />
                  <div
                    class="error-message"
                    *ngIf="billingAddressForm.get('Street')?.hasError('required') && haSubmittedBillingAddress"
                  >
                    {{
                      'fgbcl.registration.payment.form.street.error.required'
                        | translate : { fgbdefault: 'Please enter a value.' }
                    }}
                  </div>
                  <div
                    class="error-message"
                    *ngIf="billingAddressForm.get('Street')?.hasError('empty') && haSubmittedBillingAddress"
                  >
                    {{
                      'fgbcl.registration.payment.form.street.error.empty' | translate : { fgbdefault: 'Street cannot be empty.' }
                    }}
                  </div>
                  <label for="Street">{{
                    'fgbcl.registration.payment.form.street.label' | translate : { fgbdefault: 'Address' }
                  }}</label>
                </div>
                <div class="form-floating">
                  <input
                    id="Town"
                    class="form-control"
                    name="Town"
                    type="text"
                    formControlName="Town"
                    [ngClass]="{
                      'is-invalid': haSubmittedBillingAddress && !!billingAddressForm.controls.Town.errors
                    }"
                  />
                  <label for="Town">{{
                    'fgbcl.registration.payment.form.city.label' | translate : { fgbdefault: 'City' }
                  }}</label>
                  <div
                    class="error-message"
                    *ngIf="billingAddressForm.get('Town')?.hasError('required') && haSubmittedBillingAddress"
                  >
                    {{
                      'fgbcl.registration.payment.form.town.error.required' | translate : { fgbdefault: 'Please enter a value.' }
                    }}
                  </div>
                  <div
                    class="error-message"
                    *ngIf="billingAddressForm.get('Town')?.hasError('empty') && haSubmittedBillingAddress"
                  >
                    {{ 'fgbcl.registration.payment.form.town.error.empty' | translate : { fgbdefault: 'Town cannot be empty.' } }}
                  </div>
                </div>

                <div class="form-floating">
                  <fgbcl-select-country
                    [label]="'fgbcl.registration.payment.form.country.label' | translate : { fgbdefault: 'Country' }"
                    formControlName="Country"
                    (countryChange)="onCountryChange($event)"
                  ></fgbcl-select-country>
                  <div
                    class="error-message"
                    *ngIf="billingAddressForm.get('Country')?.hasError('required') && haSubmittedBillingAddress"
                  >
                    {{
                      'fgbcl.registration.payment.form.country.error.required'
                        | translate : { fgbdefault: 'Please enter a value.' }
                    }}
                  </div>
                  <div
                    class="error-message"
                    *ngIf="billingAddressForm.get('Country')?.hasError('empty') && haSubmittedBillingAddress"
                  >
                    {{
                      'fgbcl.registration.payment.form.country.error.empty'
                        | translate : { fgbdefault: 'Country cannot be empty.' }
                    }}
                  </div>
                </div>

                <div class="form-floating">
                  <fgbcl-select-region
                    formControlName="County"
                    [label]="'fgbcl.registration.payment.form.state.label' | translate : { fgbdefault: 'State' }"
                    [options]="regions"
                  ></fgbcl-select-region>

                  <div
                    class="error-message"
                    *ngIf="billingAddressForm.get('County')?.hasError('required') && haSubmittedBillingAddress"
                  >
                    {{
                      'fgbcl.registration.payment.form.county.error.required'
                        | translate : { fgbdefault: 'Please enter a value.' }
                    }}
                  </div>
                  <div
                    class="error-message"
                    *ngIf="billingAddressForm.get('County')?.hasError('empty') && haSubmittedBillingAddress"
                  >
                    {{
                      'fgbcl.registration.payment.form.county.error.empty' | translate : { fgbdefault: 'County cannot be empty.' }
                    }}
                  </div>
                </div>

                <div class="form-floating">
                  <input
                    id="Postcode"
                    class="form-control"
                    name="Postcode"
                    type="text"
                    formControlName="Postcode"
                    [ngClass]="{
                      'is-invalid': haSubmittedBillingAddress && !!billingAddressForm.controls.Postcode.errors
                    }"
                  />
                  <label for="Postcode">{{
                    'fgbcl.registration.payment.form.postcode.label' | translate : { fgbdefault: 'Zip Code' }
                  }}</label>
                  <div
                    class="error-message"
                    *ngIf="billingAddressForm.get('Postcode')?.hasError('required') && haSubmittedBillingAddress"
                  >
                    {{
                      'fgbcl.registration.payment.form.postcode.error.required'
                        | translate : { fgbdefault: 'Please enter a postcode.' }
                    }}
                  </div>
                  <div
                    class="error-message"
                    *ngIf="billingAddressForm.get('Postcode')?.hasError('empty') && haSubmittedBillingAddress"
                  >
                    {{
                      'fgbcl.registration.payment.form.postcode.error.empty'
                        | translate : { fgbdefault: 'Postcode cannot be empty.' }
                    }}
                  </div>
                  <div
                    class="error-message"
                    *ngIf="billingAddressForm.get('Postcode')?.hasError('pattern') && haSubmittedBillingAddress"
                  >
                    {{
                      'fgbcl.registration.payment.form.postcode.error.pattern'
                        | translate : { fgbdefault: 'Please enter a valid postcode.' }
                    }}
                  </div>
                </div>
              </form>
              <div class="d-flex justify-content-between action-wrapper">
                <button class="btn btn-danger cancel-btn" (click)="cancelBillingForm()">
                  {{ 'fgbcl.registration.payment.form.cancel.button' | translate : { fgbdefault: 'Cancel' } }}
                </button>
                <button class="btn btn-success save-btn" (click)="updateBillingAddress()">
                  {{ 'regustration.payment.form.save.button' | translate : { fgbdefault: 'Save' } }}
                </button>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </div>
</div>

<!-- Address Card -->
<ng-template #addressTemplate let-address let-title="title" let-type="type">
  <div class="card address-card">
    <div class="address-card-header">
      <h5 class="registration-payment-address-title">{{ title }}</h5>

      <span class="edit-btn text-primary font-size-14 fw-bold cursor-pointer" (click)="editBillingAddress()">{{
        'billing.edit.btn' | translate
      }}</span>
    </div>
    <div class="registration-payment-address">
      <div class="address-container flex-wrap">
        <ng-container *ngTemplateOutlet="addressName; context: { $implicit: address.Street }"></ng-container>
        <ng-container *ngTemplateOutlet="addressName; context: { $implicit: address.Town }"></ng-container>
        <ng-container *ngTemplateOutlet="addressName; context: { $implicit: address.County }"></ng-container>
        <ng-container *ngTemplateOutlet="addressName; context: { $implicit: address.Country }"></ng-container>
        <ng-container *ngTemplateOutlet="addressName; context: { $implicit: address.Postcode, lastItem: true }"></ng-container>
      </div>
    </div>
  </div>

  <!-- Template to display comma if address is not null -->
  <ng-template #addressName let-item let-lastItem="lastItem">
    <ng-container *ngIf="item">{{ item }}<ng-container *ngIf="!lastItem">, </ng-container></ng-container>
  </ng-template>
</ng-template>

<!-- Payment Modal -->
<ng-template #paymentModal>
  <div class="registration-payment-modal">
    <div class="registration-payment-add-payment-modal-header">
      <h5 class="registration-payment-modal-title fw-bold">
        {{ 'fgbcl.registration.payment.modal.title' | translate : { fgbdefault: 'Add Payment Details' } }}
      </h5>
      <button class="close-btn text-white" (click)="closeModal()"><i class="material-icons">close</i></button>
    </div>
    <!-- <div class="payment-info">
      <p>
        <span class="total-label">{{
          'fgbcl.registration.payment.modal.total.label' | translate : { fgbdefault: 'Total:' }
        }}</span>
        <span class="total-amount">{{ totalBasketPrice / 100 | FortressCurrencyPipe }}</span>
      </p>
    </div> -->
    <div class="payment-container bg-white">
      <div class="payment-form">
        <!-- Payment Provider Form -->
        <div id="paymentdiv"></div>
      </div>
    </div>
    <div class="action-wrapper">
      <button class="btn text-white fw-bold cancel-btn" (click)="closeModal()">
        {{ 'registration.payment.modal.cancel.button' | translate : { fgbdefault: 'Cancel' } }}
      </button>
    </div>
  </div>
</ng-template>

<ng-template #unappliedGiftCodeModal let-modal>
  <div class="text-center transfer-status-modal">
    <p class="fw-bold text-center text-danger mt-4 mb-0">
      {{
        'fgbcl.registration.payment.modal.giftcode.not.applied.title'
          | translate : { fgbdefault: 'The following gift code has not been applied:' }
      }}
    </p>
    <p class="text-info unapplied-code-instruction">
      {{
        'fgbcl.registration.payment.modal.giftcode.not.applied.instruction'
          | translate : { fgbdefault: 'Please remove or apply this code' }
      }}
    </p>
    <p class="fw-bold text-center text-success my-4">
      {{ giftCodeInput }}
    </p>
    <div class="d-flex justify-content-between mx-lg-4 mx-2">
      <button class="btn btn-danger fw-bold my-4" (click)="modal.dismiss('close'); removeUnappliedGiftCode()">
        {{ 'fgbcl.registration.payment.modal.remove.button' | translate : { fgbdefault: 'Remove Code' } }}
      </button>
      <button class="btn btn-success fw-bold my-4" (click)="modal.dismiss('close'); applyGiftCode()">
        {{ 'fgbcl.registration.payment.modal.apply.button' | translate : { fgbdefault: 'Apply Code' } }}
      </button>
    </div>
  </div>
</ng-template>

<!-- LOADING SPINNER  -->
<ng-template #loading>
  <div class="text-center p-4">
    <fgbcl-loading></fgbcl-loading>
  </div>
</ng-template>
